import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

// Static portion hoisted to module scope so it's not re-allocated each render.
const BAR_BASE_STYLE = {
  background: 'linear-gradient(90deg, #a855f7, #8b5cf6)',
  boxShadow: '0 0 10px rgba(168, 85, 247, 0.5)',
};

export const LoadingBar = () => {
  const [progress, setProgress] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsLoading(true);
    setProgress(30);

    const timer1 = setTimeout(() => setProgress(60), 100);
    const timer2 = setTimeout(() => setProgress(90), 300);
    const timer3 = setTimeout(() => {
      setProgress(100);
      setTimeout(() => {
        setIsLoading(false);
        setProgress(0);
      }, 200);
    }, 500);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [location]);

  const style = useMemo(() => ({ ...BAR_BASE_STYLE, width: `${progress}%` }), [progress]);

  if (!isLoading && progress === 0) return null;

  return (
    <div
      className="fixed top-0 left-0 right-0 h-1 z-50 transition-all duration-300 ease-out"
      style={style}
    />
  );
};
